import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "filter-summary",
  class FilterSummary extends SearchspringComponent {
    constructor() {
      super();

      this.headingTemplate = this.querySelector('[data-template="heading"]');
      this.listTemplate = this.querySelector('[data-template="list"]');
      this.itemTemplate = this.querySelector('[data-template="item"]');
      this.clearTemplate = this.querySelector('[data-template="clear-all"]');
    }

    render({ filterSummary }) {
      if (!filterSummary) {
        return;
      }

      const heading = this.headingTemplate.content.cloneNode(true);
      this.appendChild(heading);

      if (filterSummary.length > 0) {
        const clear = this.clearTemplate.content.cloneNode(true);
        this.appendChild(clear);
      }

      const list = this.listTemplate.content
        .cloneNode(true)
        .querySelector('[data-template-element="list"]');

      filterSummary.forEach((result) => {
        const item = this.itemTemplate.content.cloneNode(true);

        item.firstElementChild.dataset.clearFilterButton =
          JSON.stringify(result);

        list.appendChild(item);
      });

      this.appendChild(list);
    }
  },
);
